"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var _ = require("lodash");
/**
 * @export
 * @class BaseItemStore
 * @implements {IBaseItemStore<T, U, N>}
 * @template T - Item interface type
 * @template U - User interface type
 * @template N - Network interface type
 */
var BaseItemStore = /** @class */ (function () {
    function BaseItemStore(notificationsStore, itemType) {
        var _this = this;
        this.notificationsStore = notificationsStore;
        this.itemType = itemType;
        this.onAddAccount = function (account) {
            _this.accounts = _this.accounts.concat([account]);
        };
        this.onRemoveAccount = function (account) {
            _this.accounts = _this.accounts.filter(function (item) { return item !== account; });
        };
        this.setAccounts = function () {
            var item = JSON.parse(JSON.stringify(_this.item));
            item["x-accounts"] = _this.accounts;
            return item;
        };
        this.addToArray = function (key, item) {
            _this.item[key] = _this.item[key].concat([item]);
        };
        this.removeFromArray = function (key, value, prop) {
            if (prop === void 0) { prop = "value"; }
            _this.item[key] = _this.item[key].filter(function (item) { return (prop ? item[prop] : item) !== value; });
        };
        this.addToParamArray = function (array, item) {
            array = array.replace(array.concat([item]));
        };
        this.removefromParamArray = function (array, value) {
            array = array.replace(array.filter(function (item) { return item !== value; }));
        };
        this.addToArrayInObj = function (obj, key, item) {
            _this.item[obj][key] = _this.item[obj][key].concat([item]);
        };
        this.removeFromArrayInObj = function (obj, key, value) {
            _this.item[obj][key] = _this.item[obj][key].filter(function (item) { return item !== value; });
        };
        this.updateDeepParam = function (param, key, value) {
            if (!_this.item[param]) {
                _this.item[param] = {};
            }
            _this.item[param][key] = value;
        };
    }
    BaseItemStore.prototype.onLoadError = function () {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.loadError = true;
        });
    };
    BaseItemStore.prototype.initialize = function (item) {
        this.item = item;
    };
    BaseItemStore.prototype.setItem = function (item) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.item = item;
            _this.loadError = false;
            _this.isLoading = false;
        });
    };
    BaseItemStore.prototype.reset = function () {
        var _this = this;
        mobx_1.transaction(function () {
            _this.item = mobx_1.observable({
                _id: null,
                date: null,
                isActive: true,
                isDeleted: false,
                network: null,
                user: null
            });
            _this.isLoading = false;
            _this.accounts = mobx_1.observable.array([], { deep: false });
        });
    };
    BaseItemStore.prototype.onLoadFailed = function (err) {
        this.onLoadError();
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to load " + this.itemType,
            timeout: 5000
        });
    };
    BaseItemStore.prototype.onSubmitSuccess = function () {
        this.notificationsStore.pushSuccessNotification({
            title: "Operation Complete",
            text: this.itemType + " updated successfully",
            timeout: 5000
        });
    };
    BaseItemStore.prototype.onSubmitFailed = function (err) {
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to update " + this.itemType,
            timeout: 5000
        });
    };
    BaseItemStore.prototype.onDeleteUserSuccess = function () {
        this.notificationsStore.pushSuccessNotification({
            title: "Operation Complete",
            text: this.itemType + " deleted successfully",
            timeout: 5000
        });
    };
    BaseItemStore.prototype.onDeleteUserError = function () {
        this.notificationsStore.pushErrorNotification({
            title: "Operation Failed",
            text: "Failed to delete " + this.itemType,
            timeout: 5000
        });
    };
    BaseItemStore.prototype.updateParam = function (key, value) {
        this.item[key] = value;
    };
    BaseItemStore.prototype.updateParams = function (partial) {
        var _this = this;
        _.forEach(partial, function (value, key) {
            _this.updateParam(key, value);
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseItemStore.prototype, "item", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseItemStore.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseItemStore.prototype, "loadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseItemStore.prototype, "accounts", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onLoadError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onAddAccount", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onRemoveAccount", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "setAccounts", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "initialize", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "setItem", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onLoadFailed", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onSubmitSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onSubmitFailed", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onDeleteUserSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "onDeleteUserError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "updateParam", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "updateParams", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "addToArray", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "removeFromArray", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "addToParamArray", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "removefromParamArray", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "addToArrayInObj", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "removeFromArrayInObj", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseItemStore.prototype, "updateDeepParam", void 0);
    return BaseItemStore;
}());
exports.default = BaseItemStore;
